import React from 'react'
import Button from '../../../Button'
import { FormHelperText, Typography } from '@material-ui/core'
import { sendEventType } from '../..'
import useStyles from './useStyles'

interface Props {
  send: sendEventType
  onClose?: () => void
}

const onDialogClose = ({ onClose, send }: Props) => {
  onClose && onClose()
  send({ type: 'CLOSE' })
}

const EmailSend: React.FC<Props> = ({ onClose, send }) => {
  const classes = useStyles()

  return (
    <>
      <Typography variant='h5' className={classes.mainTitle}>
        密碼重置信已寄出
      </Typography>
      <FormHelperText className={classes.heplerText}>收到密碼重置信後，您即可打開信中的鏈結重置密碼 (鏈結10分鐘即失效)。</FormHelperText>
      <Button type='submit' onClick={() => onDialogClose({ onClose, send })}>
        我知道了
      </Button>
    </>
  )
}

export default EmailSend
